var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EargoButton } from '@/components/eargo-button.component';
import { NavigationButton } from '@/components/navigation-button.component';
export function FeedbackNavigation(_a) {
    var isSubmitSuccessful = _a.isSubmitSuccessful;
    return (_jsxs("div", __assign({ className: 'relative flex flex-col-reverse w-full items-center justify-center lg:flex-row lg:space-x-5 mb-8 px-2 lg:px-10 self-end' }, { children: [_jsx(NavigationButton, __assign({ variant: 'outlined', className: 'mt-4 w-full py-3 sm:w-full lg:mt-0 lg:basis-1/2', navigate: '/result-category/normal' }, { children: "Cancel" })), isSubmitSuccessful ? (_jsx(NavigationButton, __assign({ variant: 'contained', className: 'mt-4 w-full sm:w-full py-3 lg:mt-0 lg:basis-1/2', navigate: '/' }, { children: "Done" }))) : (_jsx(EargoButton, __assign({ variant: 'contained', className: 'w-full py-3 lg:mt-0 lg:basis-1/2', type: "submit", form: "feedback-form" }, { children: "Submit" })))] })));
}
